import { Link } from "@tanstack/react-router";
import logoLight from "@/assets/creategy-logo.svg.asset.json";
import logoDark from "@/assets/creategy-logo-white.svg.asset.json";

type LogoProps = {
  className?: string;
  variant?: "light" | "dark";
};

export function Logo({ className = "h-7 md:h-8", variant = "light" }: LogoProps) {
  const asset = variant === "dark" ? logoDark : logoLight;
  return (
    <Link to="/" aria-label="creategy – Startseite" className="inline-flex items-center">
      <img
        src={asset.url}
        alt="creategy"
        className={`${className} w-auto`}
        loading="eager"
        decoding="async"
      />
    </Link>
  );
}
